import { RequestModes_ } from "./constants";

export const ReturnCreationTabTriggers = [
  {
    value: "stock-non-vendable",
    mode: RequestModes_.NON_VENDABLE,
    text: "Stock non vendable",
  },
  {
    value: "stock-vendable",
    mode: RequestModes_.VENDABLE,
    text: "Stock vendable",
  },
  {
    value: "stock-mm",
    mode: RequestModes_.ENTREPOT,
    text: "Entrepot",
  },
];
